import { render, staticRenderFns } from "./ValidationRoyaList.vue?vue&type=template&id=65d3d279&"
import script from "./ValidationRoyaList.vue?vue&type=script&lang=js&"
export * from "./ValidationRoyaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports